var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 4C41.2517 4 52 14.7446 52 28C52 41.2554 41.2517 52 28 52C14.7446 52 4 41.2554 4 28C4 14.7446 14.7446 4 28 4ZM28 8C16.9538 8 8 16.9538 8 28C8 39.0462 16.9538 48 28 48C39.0439 48 48 39.0449 48 28C48 16.9551 39.0439 8 28 8ZM27 16.0002C28.1046 16.0002 29 16.8956 29 18.0002V28.2074L38.7491 32.1458C39.7733 32.5595 40.2681 33.7251 39.8544 34.7493C39.4407 35.7735 38.275 36.2683 37.2509 35.8546L26.2509 31.4108C25.4949 31.1055 25 30.3718 25 29.5564V18.0002C25 16.8956 25.8954 16.0002 27 16.0002Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/IconClock.255bf23f7ed65d5814923dd4ea9379d9.svg";
export { ForwardRef as ReactComponent };